import resetPasswordActions from '../actionTypes/resetPasswordActions';

const initialState = {
  isSubmitting: false,
  success: false,
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case resetPasswordActions.resetPassword:
      return { ...state, isSubmitting: true };
    case resetPasswordActions.resetPasswordSuccess:
      return {
        ...state, isSubmitting: false, openModal: false, success: true,
      };
    case resetPasswordActions.resetPasswordFailed:
      return { ...state, isSubmitting: false };

    case resetPasswordActions.changePassword:
      return { ...state, isSubmitting: true };
    case resetPasswordActions.changePasswordSuccess:
    case resetPasswordActions.changePasswordFailed:
      return { ...state, isSubmitting: false };
    case resetPasswordActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};

export default resetPasswordReducer;
